import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";
import { candidate_inception_assessment_routes } from "./sub_routes/candidates/candidate_inception_assessment_routes";

export const candidates_routes: RouteConfig = {
  path: "/candidate",
  component: () => import("@/views/candidate/CandidateWrapper.vue"),
  meta: {
    user_state: [UserState.CANDIDATE]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "candidate-dashboard"
      }
    },
    {
      path: "dashboard",
      name: "candidate-dashboard",
      component: () =>
        import("@/views/candidate/InceptionCandidateDashboard.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      },
      children: []
    },
    {
      path: "dashboard-intro",
      name: "dashboard-intro",
      component: () => import("@/views/candidate/CandidateDashboardIntro.vue"),
      meta: {
        name: "dashboard-intro",
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "survey",
      name: "survey-questions",
      component: () => import("@/views/candidate/SurveyQuestions.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      },
      children: []
    },
    {
      path: "profile",
      name: "personal-profile",
      component: () => import("@/views/candidate/ViewProfile.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "profile-loading",
      name: "profile-fetching",
      component: () => import("@/views/candidate/ProfileLoading.vue"),
      meta: {
        user_state: [UserState.CANDIDATE_PROFILE_PENDING]
      }
    },
    // candidate_assessment_routes,
    candidate_inception_assessment_routes,
    {
      path: "ai-assessments",
      name: "candidate-ai-assessments",
      component: () =>
        import("@/views/candidate/ai-assessments/CandidateAiAssessments.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "error",
      name: "candidate-error",
      component: () => import("@/views/ErrorPage.vue"),
      meta: {
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "*",
      component: () => import("../views/NotFound.vue"),
      meta: {
        user_state: [
          UserState.UNAUTHENTICATED,
          UserState.EMAIL_VERIFICATION_PENDING,
          UserState.EMAIL_VERIFICATION_COMPLETED,
          UserState.ONBOARDING_PENDING,
          UserState.RECRUITER,
          UserState.RECRUITER_ADMIN,
          UserState.CANDIDATE
        ]
      }
    }
  ]
};
